import { convertGridToPixels } from "../../../Pages/FlexibleLayout/utils";
import { newProcessLayout } from "../../GridLayoutFunc";
import { getLayoutDataOfDetailviewElements, getUpdatedDataOfRVColumnsAndFilters } from "../../InitialRenderingData";

export const getInitialConfigForRecordsview = (config, options) => {
  if (config.device === "desktop" || config.device === "tablet") {
    return getInitialConfigOfDesktopRecordsview(config, options);
  }
  if (config.device === "mobile") {
    return getInitialConfigOfMobileRecordsview(config, options);
  }
};

export const getInitialConfigOfDesktopRecordsview = (config, options) => {
  const rvconfig = JSON.parse(JSON.stringify(config));
  const catalog = getLayoutDataOfDetailviewElements(rvconfig.config.layout.catalog.elements, options.tableData);
  const { layout, layoutData, nestedGridData } = catalog;

  const updatedLayoutData = getUpdatedDataOfRVColumnsAndFilters(
    {
      columns: rvconfig.config.layout.columns,
      onscreen_filters: rvconfig.config.layout.onscreen_filters,
      pre_filters: rvconfig.config.layout.pre_filters
    },
    options.tableData
  );

  rvconfig.config.layout = { ...rvconfig.config.layout, ...updatedLayoutData };

  const { elements } = newProcessLayout(layoutData, nestedGridData, layout);
  rvconfig.config.layout.catalog.elements = elements;
  return { config: rvconfig, options: { catalog } };
};

export const getInitialConfigOfMobileRecordsview = (config, options) => {
  const rvconfig = JSON.parse(JSON.stringify(config));

  const catalog = getLayoutDataOfDetailviewElements(rvconfig.config.layout.catalog.elements, options.tableData);
  const { layout, layoutData, nestedGridData } = catalog;
  let { elements } = newProcessLayout(layoutData, nestedGridData, layout);

  rvconfig.config.layout.catalog.elements = elements;

  let positionLayoutConfig = convertGridToPixels(
    rvconfig.position_block_config || [],
    rvconfig.position_block_metadata?.grid_size || 4
  );

  return { config: rvconfig, options: { catalog, positionLayoutConfig } };
};
